/**
 * Icon Mapper Utility
 * Maps keywords in node labels to appropriate icons
 */

const iconMap = [
  // Fundamentals and Basics
  { keywords: ['fundamental', 'basic', 'basics', 'introduction', 'intro', 'overview', 'getting started'], icon: '🎓' },
  
  // Strategies and Tactics
  { keywords: ['strategy', 'strategies', 'tactic', 'tactics', 'method', 'approach', 'plan'], icon: '💡' },
  
  // Warnings and Avoid
  { keywords: ['avoid', 'warning', 'warnings', 'danger', 'risk', 'don\'t', 'never'], icon: '⚠️' },
  
  // Banking and Financial
  { keywords: ['bank', 'banking', 'financial', 'finance', 'credit', 'lender', 'loan'], icon: '🏦' },
  
  // Tools and Workflow
  { keywords: ['tool', 'tools', 'workflow', 'process', 'template', 'checklist', 'guide'], icon: '🔧' },
  
  // Advanced
  { keywords: ['advanced', 'expert', 'specialist', 'master', 'pro', 'elite'], icon: '🎯' },
  
  // Data and Reports
  { keywords: ['score', 'report', 'reports', 'data', 'analytics', 'monitoring', 'tracking', 'bureau'], icon: '📊' },
  
  // Search and Discovery
  { keywords: ['search', 'find', 'discover', 'explore', 'browse'], icon: '🔍' },
  
  // Phase and Stages
  { keywords: ['phase', 'stage', 'stages', 'step', 'steps', 'module'], icon: '📘' },
  
  // Health and Maintenance
  { keywords: ['health', 'maintain', 'maintenance', 'care', 'protect', 'protection'], icon: '🛡️' },
  
  // Leverage and Growth
  { keywords: ['leverage', 'growth', 'scale', 'scaling', 'build', 'building'], icon: '🚀' },
  
  // Debt Management
  { keywords: ['debt', 'payoff', 'repayment', 'balance', 'utilization'], icon: '💰' },
  
  // Repair and Fix
  { keywords: ['repair', 'fix', 'dispute', 'remove', 'clean', 'cleanup'], icon: '🔨' },
];

/**
 * Get icon for a node based on its label
 * @param {string} label - The node label
 * @returns {string} - The emoji icon
 */
export function getIconForLabel(label) {
  if (!label) return '📄';
  
  const lowerLabel = label.toLowerCase();
  
  // Check for exact matches first (more specific)
  for (const mapping of iconMap) {
    for (const keyword of mapping.keywords) {
      if (lowerLabel.includes(keyword)) {
        return mapping.icon;
      }
    }
  }
  
  // Default icon if no match
  return '📄';
}

/**
 * Get custom icon mapping (for future extensibility)
 * @param {Object} customMap - Custom icon mapping object
 * @param {string} label - The node label
 * @returns {string} - The emoji icon
 */
export function getCustomIcon(customMap, label) {
  if (!customMap || !label) return getIconForLabel(label);
  
  const lowerLabel = label.toLowerCase();
  for (const [key, icon] of Object.entries(customMap)) {
    if (lowerLabel.includes(key.toLowerCase())) {
      return icon;
    }
  }
  
  return getIconForLabel(label);
}

export default getIconForLabel;

